import axios from "axios";
export const API_URL = "/api/v1";
export const SAVE_WASTE_COLLECT_URL = API_URL+"/waste_collect/save_waste_collect/";
export const UPDATE_WASTE_COLLECT_REPORT_URL = API_URL+"/waste_collect/update_waste_collect_report/";
export const GET_COLLECT_SCHEDULE_URL = API_URL+"/collect_schedule/get_collection_route/";
export const SAVE_COLLECT_SCHEDULE_URL = API_URL+"/collect_schedule/save_collection_route/";
export const DELETE_SCHEDULE_URL = API_URL+"/collect_schedule/delete_collection_route/";
export const SAVE_DISPOSE_URL = API_URL+"/dispose/save_dispose/";
export const GET_WASTE_BIN_LIST_URL = API_URL+"/waste_bin/owner_data_list/";
export const GET_WASTE_COLLECT_URL = API_URL+"/waste_collect/get_waste_collect/";


export function saveWasteCollect(params) {
  return axios.post(SAVE_WASTE_COLLECT_URL, params);
}

export function updateWasteCollectReport(params) {
  return axios.post(UPDATE_WASTE_COLLECT_REPORT_URL, params);
}

export function getCollectScheduleData(params) {
  return axios.get(GET_COLLECT_SCHEDULE_URL + '?car='+ params.car + '&driver=' + params.driver + '&collect_date='+params.collect_date);
}

export function saveCollectSchedule(params) {
  return axios.post(SAVE_COLLECT_SCHEDULE_URL, params);
}

export function deleteCollectSchedule(params) {
  return axios.post(DELETE_SCHEDULE_URL, params);
}

export function saveDispose(params) {
  return axios.post(SAVE_DISPOSE_URL, params);
}

export function getWasteBinList(company_id) {
  return axios.get(GET_WASTE_BIN_LIST_URL + '?company=' + company_id);
}

export function getWasteCollect(params) {
  return axios.get(GET_WASTE_COLLECT_URL + '?company='+ params.company + '&start_date=' + params.startDate + '&end_date='+params.endDate);
}

